import { CircularGauge } from '@progress/kendo-react-gauges';
import { useLocalization } from '@progress/kendo-react-intl';

export const ConversionsChart = (values?: any) => {

  const localizationService = useLocalization();


  const firstValue = values.firstValue
  const secondValue = values.secondValue

  const arcOptions = {
    value: values.firstValue,
    transitions: false,
  };

  const arcSecondOptions = {
    value: values.secondValue,
    transitions: false,
  };

  const arcCenterRenderer = () => {
    return (
      <div>
        <h3 style={{fontSize: "2cqw", fontWeight: 'bold', color:'#198894'}}>
          {firstValue}
        </h3>        
      </div>
    );
  };

  const secondArcCenterRenderer = () => {
    return (
      <h3  style={{fontSize: "2cqw", fontWeight: 'bold', color:'#198894'}}>
        {secondValue}
      </h3>
    );
  };
  return (
    <div className="circular-gauge-container" style={{justifyContent: 'center'}}>
      <div>
        <CircularGauge 
          {...arcOptions} 
          arcCenterRender={arcCenterRenderer} 
          style={{ height: '120px' }}
          color='#5FE406'
          scale={{
            startAngle: 90,
          }} />
          <h4
            style={{
              fontSize: '20px',
              color: '#666666',
              textAlign: 'center'
            }}
          >{localizationService.toLanguageString('dashboard.widget.devices.active', 'NOT FOUND')}</h4>
          <br />
          {/* <h3
            style={{
              fontSize: '20px',
              color: '#666666'
            }}
          >1,500,200</h3> */}
      </div>

      <div>
        <CircularGauge 
          {...arcSecondOptions} 
          arcCenterRender={secondArcCenterRenderer} 
          style={{ height: '120px' }} 
          color='#FF6358'
          scale={{
            startAngle: 90,
          }} />          
          <h4
            style={{
              fontSize: '20px',
              color: '#666666',
              textAlign: 'center'
            }}
          >{localizationService.toLanguageString("dashboard.widget.devices.inactive", 'NOT FOUND')}</h4>
          <br />
          {/* <h3
            style={{
              fontSize: '20px',
              color: '#666666'
            }}
          >1,500,200</h3> */}
        </div>
      </div>
  );
};
